// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.83.0',
  revision: 'bb7040b3f',
  branch: 'master',
  date: 'Thu, 15 Jan 2026 10:44:28 GMT'
};